import { render, staticRenderFns } from "./PackageUpgradeVirtualModal.vue?vue&type=template&id=46845227&scoped=true"
import script from "./PackageUpgradeVirtualModal.vue?vue&type=script&lang=ts"
export * from "./PackageUpgradeVirtualModal.vue?vue&type=script&lang=ts"
import style0 from "./PackageUpgradeVirtualModal.vue?vue&type=style&index=0&id=46845227&prod&scoped=true&lang=css"
import style1 from "./PackageUpgradeVirtualModal.vue?vue&type=style&index=1&id=46845227&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46845227",
  null
  
)

export default component.exports